import { CALENDAR_SCROLL_INSET_VALUE } from '@/shared/lib/calendarLayout.constants';

export { CALENDAR_GRID_WIDTH_COMPENSATION } from '@/shared/lib/calendarLayout.constants';

export const CALENDAR_PANEL_BASE_STYLES = {
  display: 'flex',
  flexDirection: 'column' as const,
  flex: '1 1 0',
  minHeight: 0,
  alignSelf: 'stretch',
  borderRadius: '14px',
  background: '#FFF',
  boxShadow: '0 1px 8px 0 rgba(0, 0, 0, 0.15)',
};

export const CALENDAR_SCROLL_BEHAVIOR_STYLES = {
  overflowY: 'auto' as const,
  overflowX: 'hidden' as const,
};

export const CALENDAR_SCROLL_CONTENT_SPACING = {
  boxSizing: 'border-box' as const,
  paddingRight: CALENDAR_SCROLL_INSET_VALUE,
};

export const CALENDAR_SCROLL_TRACK_TRANSFORM = 'translateX(0)';
